import {Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';

type MatSizeType = 'sm' | 'lg' | 'md';

const MatSizeClassMap = {
  sm: 'mat-size-sm',
  lg: 'mat-size-lg',
  md: 'mat-size-md',
};

@Component({
  selector: 'nw-number-select',
  templateUrl: './number-select.component.html',
  styleUrls: ['./number-select.component.scss'],
})
export class NewellNumberSelectComponent implements OnInit, OnChanges {
  @Input() min: number = 0;
  @Input() max: number = 0;
  @Input() disabled: boolean = false;
  @Input() size: MatSizeType = 'md';
  @Input() readonly: boolean = false;
  @Input() value: number = 0;

  @Output() change = new EventEmitter<number>();
  @Output() valueChange = new EventEmitter<number>();

  public maxOut: boolean = false;
  public minOut: boolean = false;
  public sizeClass: string;

  constructor() {}

  ngOnInit(): void {
    this.value = this.validateValue(this.value);
    this.sizeClass = MatSizeClassMap[this.size];
  }

  ngOnChanges() {
    this.value = this.validateValue(this.value);
  }

  private _emitter(value) {
    this.change.emit(value);
    this.valueChange.emit(value);
  }

  private validateValue(value): number {
    if (value >= this.max) {
      this.minOut = false;
      this.maxOut = true;
      return this.max;
    }

    if (value <= this.min) {
      this.minOut = true;
      this.maxOut = false;
      return this.min;
    }

    if (value > this.min && value < this.max) {
      this.minOut = false;
      this.maxOut = false;

      return value;
    }
  }

  increment(): void {
    const newValue = this.validateValue(this.value + 1);
    this._emitter(newValue);
  }

  decrement(): void {
    const newValue = this.validateValue(this.value - 1);
    this._emitter(newValue);
  }

  onChange(value: number): void {
    const newValue = this.validateValue(+value);
    this._emitter(newValue);
  }
}
